import formats from '../../api/formats'

export default {
  computed: {
    formats () {
      return formats
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/apimix.js